import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect, Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "./redux/actions";
import * as agentInfoVerificationsActions from '../agent-info-verification/redux/actions';
import { default as Login } from "../login/Login";
import { default as Schedules } from "../schedules/Schedules/Schedules";
import { default as TimeOff } from "../timeoff/TimeOff/TimeOff";
import { default as Scorecard } from "../scorecard/Scorecard";
import { default as PerformanceMetrics } from "../scorecard/PerformanceMetrics";
import { default as ContestLeaderboard } from "../contests/ContestLeaderboard";
import { default as AgentCoaching } from '../agent-coaching/AgentCoaching';
import { default as OpportunityPage } from '../agent-coaching/OpportunityPage';
import { isLoggedIn as isAuthorized } from "auth";
import { default as NotificationDropdown } from "../common/Notifications/NotificationDropdown";
import * as performanceMetricsDataActions from '../scorecard/redux/performance_metrics_grid_data_actions';
import AgentInfoVerification from '../agent-info-verification/components/AgentInfoVerification';
import AgentLockedOutConfirmation from '../agent-info-verification/components/AgentLockedOutConfirmation';
import isSupervisor from '../agent-info-verification/util/isSupervisor';

class Nav extends Component {
	componentDidMount = async 	() => {
		const { 
			User,
			actions: { getAgentVerificationInfoAction, agentVerificationLocationFlagAction }
		} = this.props;
		// for refresh, check agent verification info
		if(User) {
			const userID = await isSupervisor(User);
			await getAgentVerificationInfoAction(userID)
			await agentVerificationLocationFlagAction(userID)
		}
	}

	componentDidUpdate = async (prevProps) => {
		const { 
			User,
			isLoggedIn,
			actions: { getAgentVerificationInfoAction, agentVerificationLocationFlagAction }
		} = this.props;
		// when agent logs in, check agent verification info
		if(prevProps.isLoggedIn !== isLoggedIn && isLoggedIn) {
			const userID = await isSupervisor(User);
			await getAgentVerificationInfoAction(userID)
			await agentVerificationLocationFlagAction(userID)
		}
	}
		
	render() {
		return (
			<Router>
				<Switch>
					<Route exact path="/" component={Login} />
					<PrivateRoute
						exact
						path="/Schedules/:date?/:agentID?/:teamID?/:muID?/:agentName?"
						component={Schedules} />
					<PrivateRoute
						exact
						path="/TimeOff"
						component={TimeOff} />
					<PrivateRoute
						exact
						path="/TimeOff/:TabType"
						component={TimeOff} />
					<PrivateRoute
						exact
						path="/Scorecard"
						component={Scorecard} />
					<PrivateRoute
						exact
						path="/PerformanceMetrics"
						component={PerformanceMetrics} />
					<PrivateRoute
						exact
						path="/AgentInfoVerification"
						component={AgentInfoVerification} />
					<PrivateRoute
						exact
						path="/AgentLockedOutConfirmation"
						component={AgentLockedOutConfirmation} />   
					<PrivateRoute
						exact
						path="/Leaderboard"
						component={ContestLeaderboard} />
					<PrivateRoute 
						exact
						path='/AgentCoaching'
						componentProps={{ 
							isCorporateUser: this.props.User && !this.props.User.supervisorAgentID,
							isManager: this.props.User && !isNaN(this.props.User.teamManagerType),
						}}
						component={AgentCoaching} />
					<PrivateRoute 
						exact
						path='/AgentCoaching/Opportunity/:opportunityId?'
						componentProps={{ user: this.props.User }}
						component={OpportunityPage} />
					<Route component={Login} />
				</Switch>
			</Router>
		);
	}
}

const PrivateRoute = ({ component: Component, ...rest, componentProps }) => (
	<Route
		{...rest}
		render={props =>
			isAuthorized() === true ? (
					<Component {...props} {...componentProps} />
			) : (
					<Redirect to="/" />
			)
		}
	/>
);

export class NavPageWrapper extends Component {
	state = {
		showDropDown: false,
		showNotificationDropDown: false,
		showTabletNavigation: false,
		navigationExpanded: false
	};

	toggleDropdown = () => {
		if(this.state.showNotificationDropDown) this.setState({ showNotificationDropDown: false });

		this.setState({ 
			showDropDown: !this.state.showDropDown,
			showTabletNavigation: !this.state.showTabletNavigation,
		});
	}

	toggleNotificationDropdown = () => {
		if(this.state.showDropDown === true) this.setState({ showDropDown: false });

		this.setState({ showNotificationDropDown: !this.state.showNotificationDropDown });
	}

	expandNavigation = () => this.setState({ navigationExpanded: !this.state.navigationExpanded });

	render() {
		let { showDropDown, showNotificationDropDown, showTabletNavigation, navigationExpanded } = this.state;
		let { wrapperClassNames, currPath, children, isTablet, isPerformanceMetricsPage } = this.props;
		let isTabletValid = isTablet && isPerformanceMetricsPage;

		return (
			<div className={isTabletValid ? "pm-tab" : ""}>
				<CTopBar 
					isPerformanceMetricsPage={isPerformanceMetricsPage} 
					onClick={() => this.toggleDropdown()} 
					onNotificationClick={() => this.toggleNotificationDropdown()}
				/>

				<CProfileDropDown 
					showDropDown={showDropDown} 
					showNotificationDropDown={showNotificationDropDown} 
					isPerformanceMetricsPage={isPerformanceMetricsPage} 
					currPath={currPath} onClick={() => this.toggleDropdown()} 
					showTabletNavigation={showTabletNavigation}
				/>

				<CSideNav 
					currPath={currPath} 
					isPerformanceMetricsPage={isPerformanceMetricsPage} 
					navigationExpanded={this.expandNavigation} 
					isNavigationExpanded={this.state.navigationExpanded} 
				/>

				<div className={`${navigationExpanded ? "wrapper wrapper-position" : "wrapper"} ${wrapperClassNames}`}>
					{children}
				</div>
			</div>
		);
	}
}

class TopBar extends Component {
	state = {
		hasNewNotifications: this.props.hasNewNotifications
	}
	
	componentWillReceiveProps(nextProps){
		if(this.props.isFetching !== nextProps.isFetching){        
			this.setState({ hasNewNotifications: nextProps.hasNewNotifications })
		}
			
		if((this.props.anyUnAckNotifications !== nextProps.anyUnAckNotifications) || this.props.acknowledCompleted !== nextProps.acknowledCompleted) {            
				this.setState({ hasNewNotifications: nextProps.anyUnAckNotifications })             
		}        
	}

	getInitials = () => {
		let { User } = this.props;
		if (User === null) return "";

		let fInitial = User.firstName === null ? "" : User.firstName.substr(0, 1);
		let lInitial = User.lastName === null ? "" : User.lastName.substr(0,1);

		return fInitial.toUpperCase() + lInitial.toUpperCase();
	}

	render() {
		let { isTablet, isPerformanceMetricsPage } = this.props;
		let isTabletValid = isTablet && isPerformanceMetricsPage;

		return (
			<div className="top-bar cf">
				<div className="actions">
					{isTabletValid ? <a href=""><img alt="logo" className="logo" /></a> : '' }
					<div className="top-bar-right-wrap">
						<div 
							className={this.state.hasNewNotifications ? "notification-circle hasNewNotifications" : "notification-circle"}
							onClick={() => this.props.onNotificationClick()}
						>
							<span className="sp-portal bell-icon"></span>
						</div>
						
						<div 
							className={isTabletValid ? "sp-portal hamburger-menu" : "initial-circle"}
							onClick={() => this.props.onClick()}
						>
							{isTabletValid ? "" : this.getInitials() }
						</div>
					</div>
				</div>
			</div>
		);
	}
}

class ProfileDropDown extends Component {
	handleLogout = () => {
		//reset user selection to scorecard cache on logout
		if(this.props.actions.updateUserToSelectedItemCacheAction) {
			let _username = this.props.User ? this.props.User.userName : null;
			if(_username) {
				var _muIds = [];
				var _agentIds = [];
				var _teamIds = [];
				
				let _data = {
					Data: {
						'UserName': _username,
						'ManagementUnitIDs': _muIds,
						'TeamIDs': _teamIds,
						'AgentIDs': _agentIds
					}
				}
				this.props.actions.updateUserToSelectedItemCacheAction(_data);
			}
		}

		if (this.props.actions.logoutAction) this.props.actions.logoutAction();
	}

	render() {
		let { showDropDown, showNotificationDropDown, User, isTablet, isPerformanceMetricsPage, currPath, showTabletNavigation } = this.props;
		let isTabletValid = isTablet && isPerformanceMetricsPage;

		return (
			<div>
				<div className={ showDropDown ? "profile_dropdown" : "profile_dropdown hide"}>
					{ isTabletValid ? 
						<div>
							<div className="nav__wrap">
								<a href="">
									<img alt="logo" className="logo" />
								</a>
								<div className="filter__modal-close" onClick={() => this.props.onClick()}></div>
							</div>
							<CSideNav 
								currPath={currPath} 
								isPerformanceMetricsPage={isPerformanceMetricsPage} 
								showTabletNavigation={showTabletNavigation}
							/>
						</div>
							
					:
						''
					}
					<ul>
						<li>
							{User !== null ? User.firstName + " " + User.lastName : ""}
						</li>
						<li onClick={() => this.handleLogout()}>
							Logout
						</li>
					</ul>
				</div>
					
				<NotificationDropdown showNotificationDropDown={showNotificationDropDown} />
			</div>
		);
	}
}

class SideNav extends Component {
	constructor(props) {
		super(props);
			
		this.state = {
			navItems: {
				agentNavItems: [
					{
						title: "Schedules",
						path: "/Schedules",
						key: "Schedules",
						icon: "calendar",
						isSelected: props.currPath.substr(0,10) === "/Schedules",
						isActive: true
					},
					{
						title: "Time Off",
						path: "/TimeOff",
						key: "Timeoff",
						icon: "plane",
						isSelected: props.currPath.substr(0,8) === "/TimeOff",
						isActive: false
					},
					{
						title: "Scorecard",
						path: "/Scorecard",
						key: "Scorecard",
						icon: "analytics",
						isSelected: props.currPath.substr(0,10) === "/Scorecard",
						isActive: false
					},
					{
						title: "Leaderboard",
						key: "Leaderboard",
						path: "/Leaderboard",
						icon: "leaderboard",
						isSelected: props.currPath.substr(0,19) === "/Leaderboard",
						isActive: false
					}
				],
				supervisorNavItems: [
					{
						title: "Agent Schedules",
						key: "AgentSchedules",
						path: "/Schedules",
						icon: "calendar",
						isSelected: props.currPath.substr(0,10) === "/Schedules",
						isActive: true
					},
					{
						title: "Agent Time Off",
						key: "AgentTimeOff",
						path: "/TimeOff/Pending",
						icon: "plane",
						isSelected: props.currPath.substr(0,8) === "/TimeOff",
						isActive: false
					},
					{
						title: "Performance Metrics",
						key: "PerformanceMetrics",
						path: "/PerformanceMetrics",
						icon: "analytics",
						isSelected: props.currPath.substr(0,19) === "/PerformanceMetrics",
						isActive: false
					},
					{
						title: "Agent Coaching",
						key: "AgentCoaching",
						path: "/AgentCoaching",
						icon: "agentcoaching",
						isSelected: props.currPath.substr(0,14) === "/AgentCoaching",
						isActive: false
				}
				]
			},
		};
	}

	setSelectedNavItem = () => {}

	generateNavItems = () => {
		let { navItems } = this.state;
		let { User, position } = this.props;
		let userNavItems = [], navItemElms = [];
		
		if (User.position === position.invalid) return null;    
		userNavItems = User.position === position.agent 
										? navItems.agentNavItems 
										: navItems.supervisorNavItems;

		for (let i = 0; i < userNavItems.length; i++) {
			let item = userNavItems[i];
				
			if(item != null && item.key === "Timeoff") {
				if(User !== null && User.isTimeOffVisible === false) {
					continue;
				}
			}

			if(item != null && item.key === "Scorecard") {
				if(User !== null && User.position !== position.agent) {
					continue;
				}
			}

			navItemElms.push(
				<li key={item.title} className={item.isSelected ? "selected" : ""}>
					<Link to={item.path}>{item.title}</Link>
					<span className={"sp-portal " + item.icon + "-icon"}></span>
				</li>
			);
		}
		return navItemElms;
	}

	render() {
		let { User, position, isTablet, isPerformanceMetricsPage, showTabletNavigation, isNavigationExpanded, navigationExpanded } = this.props;
		let isSupervisor = User.position !== position.agent;
		let isTabletValid = isTablet && isPerformanceMetricsPage
			
		return (
			<div className="side-nav-container">
				{ isTabletValid ? 
					showTabletNavigation ?
						<ul className={ isSupervisor ? "supervisor" : "" }>{this.generateNavItems()}</ul> : '' 
					:
						<div onClick={navigationExpanded} className={ isNavigationExpanded ? "side-nav nav-expanded" : "side-nav"}>
							<a href="">
								<img alt="logo" className="logo" />
							</a>
							{ isSupervisor ? 
								<div className="block-wrap">
									<div className={ isNavigationExpanded ? "supervisor-view-block" : "supervisor-view-block hide"}>
										Supervisor View
									</div>
								</div>
							: 
								<div className="block-wrap"></div>
							}
							<ul className={ isSupervisor ? "supervisor" : "" }>
								{this.generateNavItems()}
							</ul>
							<div 
								onClick={ navigationExpanded}
								className={ isNavigationExpanded ? "collapse__menu" : "collapse__menu hide"}
							>
								Collapse Menu &raquo;
							</div>
						</div>
				}
			</div>
		);
	}
}

function mapStateToProps({
	common: { 
		user: User,
		isLoggedIn,
		isFetching,
		position,
		hasNewNotifications,
		notifications,
		anyUnAckNotifications,
		acknowledCompleted,
		isTablet}
}) {
	return {
		isLoggedIn,
		isFetching,
		User,
		position,
		hasNewNotifications,
		notifications,
		anyUnAckNotifications,
		acknowledCompleted,
		isTablet,
	};
}

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators({ ...actions, ...performanceMetricsDataActions, ...agentInfoVerificationsActions }, dispatch)});

export default connect(mapStateToProps, mapDispatchToProps)(Nav);

const CProfileDropDown = connect(mapStateToProps, mapDispatchToProps)(ProfileDropDown);

const CTopBar = connect(mapStateToProps, mapDispatchToProps)(TopBar);

const CSideNav = connect(mapStateToProps, mapDispatchToProps)(SideNav);




// WEBPACK FOOTER //
// ./src/features/common/Nav.js